import { useCallback, useLayoutEffect, useRef } from 'react'
import { useKeyboardInteraction } from './use-keyboard-interaction'

/**
 * A popup's `finalFocus` that hands focus back only when the keyboard opened it.
 * Handed back after a pointer open, focus arrives on the Escape that closed the
 * popup, so whatever it returns to shows a focus ring nobody tabbed to.
 */
function useKeyboardFinalFocus(open: boolean): () => boolean {
  const isKeyboardInteraction = useKeyboardInteraction()
  const openedByKeyboard = useRef(false)

  // Read as it opens, before any key pressed inside the popup counts.
  useLayoutEffect(() => {
    if (open) openedByKeyboard.current = isKeyboardInteraction()
  }, [open, isKeyboardInteraction])

  return useCallback(() => openedByKeyboard.current, [])
}

export { useKeyboardFinalFocus }
